/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {showPopupInMenu} from '../../../../common/menu/actions';
import {FormattedNumber} from 'react-intl';
import Currency from '../../../components/numbers/Currency';

class DetailPopup extends React.Component {

    static propTypes = {
        showPopupInMenu: React.PropTypes.func,
        bills: React.PropTypes.object,
        detailDebtItemsId: React.PropTypes.number
    };

    constructor(props) {
        super(props);

        this.pay = this.pay.bind(this);
    }

    pay() {
        const {showPopupInMenu} = this.props;
        showPopupInMenu(false);
    }

    render() {
        const {bills, detailDebtItemsId} = this.props;
        if (bills.size = 0 || detailDebtItemsId === null) {
            return null;
        }

        const bill = bills.find(t => t.get('id') === detailDebtItemsId);
        if (!bill) {
            return null;
        }

        return (
            <div className="printReceipt">
              <h1 className="popup-title printReceipt-title">{bill.get('title')}</h1>
                <table className="printReceipt-table">
                    <tbody>
                    {!!bill.get('items') && bill.get('items').map((item, i) =>
                        <tr key={`print-item-${i}`}>
                            <td className="printReceipt-pcs">{item.get('pcs')}x</td>
                            <td className="printReceipt-item">{item.get('name')} (<FormattedNumber
                                style="decimal"
                                maximumFractionDigits={2}
                                minimumFractionDigits={2}
                                value={(item.get('price')).toFixed(2)}/>)
                            </td>
                            <td className="printReceipt-price">
                                {typeof item.get('pcs') !== 'undefined' &&
                                <FormattedNumber
                                    style="decimal"
                                    maximumFractionDigits={2}
                                    minimumFractionDigits={2}
                                    value={(item.get('price') * item.get('pcs')).toFixed(2)}/>
                                }
                            </td>
                        </tr>
                    )}

                    </tbody>
                </table>
                <div className="printReceipt-total" id="total">
                  <Currency currency={bill.get('currency')} value={Math.round(bill.get('totalAmount'))}/> {}
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    bills: state.menuDebtDetail.get('bills'),
    detailDebtItemsId: state.menuDebtDetail.get('detailDebtItemsId')
}), {showPopupInMenu})(DetailPopup);



// WEBPACK FOOTER //
// ./src/browser/menu/credit/debtDetail/DetailPopup.js